import { combineReducers } from 'redux';
import userManagementSlice from '../views/user-management/state/userManagementSlice';
import engineApiTokens from '../views/engine-api-tokens/state/engineApiTokensSlice';

export default combineReducers({
    userManagement: userManagementSlice,
    engineApiTokens,
});
